import React from 'react';
import { ReactComponent as ColorScheme } from '../../assets/images/icons/colorScheme.svg';

export default function ColorSchemeIcon({ className }) {
  return (
    <ColorScheme className={`icon ${className}`} />
  );
}
